import React, { createContext, useContext, useEffect, useState } from 'react';
import { translate, translateWithLanguage, supportedLanguages } from '../i18n/i18n';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('fr');

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem('app_language');
      if (stored && supportedLanguages.includes(stored)) {
        setLanguageState(stored);
      }
    } catch (_) {}
  }, []);

  const setLanguage = (lang) => {
    if (!supportedLanguages.includes(lang)) return;
    setLanguageState(lang);
    try {
      window.localStorage.setItem('app_language', lang);
    } catch (_) {}
  };

  const value = {
    language,
    setLanguage,
    t: (key) => translate(language, key),
    tWithLanguage: (lang, key) => translateWithLanguage(lang || language, key),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
};
